import { render, staticRenderFns } from "./overall.vue?vue&type=template&id=2478f84a&scoped=true&"
import script from "./overall.vue?vue&type=script&lang=js&"
export * from "./overall.vue?vue&type=script&lang=js&"
import style0 from "./overall.vue?vue&type=style&index=0&id=2478f84a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478f84a",
  null
  
)

export default component.exports